import { render } from "./FetchRepo.vue?vue&type=template&id=6677aa12&scoped=true"
import script from "./FetchRepo.vue?vue&type=script&lang=js"
export * from "./FetchRepo.vue?vue&type=script&lang=js"

import "./FetchRepo.vue?vue&type=style&index=0&id=6677aa12&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6677aa12"]])

export default __exports__